import { useState } from 'react';

import { useAppDispatch } from 'store/store';
import { getAllPaymentMethods } from 'store/user-service/asyncActions';

export const useGetPaymentMethods = () => {
	const [gettingPaymentLoading, setGettingPaymentLoading] = useState(false);
	const dispatch = useAppDispatch();

	const handleGetAllPaymentsMethods = async () => {
		setGettingPaymentLoading(true);
		try {
			await dispatch(getAllPaymentMethods({ recordsPerPage: 5 })).unwrap();
		} catch (error) {
			console.log(error);
		} finally {
			setGettingPaymentLoading(false);
		}
	};

	return { gettingPaymentLoading, handleGetAllPaymentsMethods };
};
